<div class=" mt-4">
    <section>
        <div class="row">
            <div class="col-md-11">
                <div class="float-right">
                    <button class="btn dash-btns mr-3"[routerLink]="['/PayOut/NewPayOutContact']">New
                        PayOut Contact </button>
                      <button class="btn dash-btns mr-3"  [routerLink]="['/PayOut/ManagePayOutContact']">Manage PayOut Contacts </button>
                      <button [routerLink]="['/reports/transactions/summary']" class="dash-btns">Reports</button>

                </div>
            </div>
        </div>

    </section>
    <section class="mt-3">
        <div class="">
            <div class="row">
                <div class="col-md-10 offset-md-1">
                    <div class="card-1">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="text-center mb-5">
                                    <img src="assets/img/new/view-trans.svg" />
                                </div>
                                <div class="text-center">
                                    <a class="view-h gary-t  ">Delete PayOut Contacts Details </a>

                                </div>

                                <div class="pt-3 row">
                                    <div class="col-md-6">
                                        <div class="row mb-3">
              
                                            <div class="col-6 p-0"> <label>Payout Customerkey Id</label> </div>
                                            
                                            <div class="col-6 p-0 view-text robot"> {{rows.PayoutCustomerkeyId}}
                                                                             </div>
                                        </div>
                                        <div class="row mb-3">
              
                                            <div class="col-6 p-0"> <label>Customer Id</label> </div>
                                            
                                            <div class="col-6 p-0 view-text robot"> {{rows.CustomerId}}</div>
                                        </div>
                                        <div class="row mb-3">
              
                                            <div class="col-6 p-0"> <label>CompanyName</label>  </div>
                                            
                                            <div class="col-6 p-0 view-text"> {{rows.CompanyName}}</div>
                                        </div>
                                        <div class="row mb-3">
              
                                            <div class="col-6 p-0"> <label> FirstName</label></div>
                                            
                                            <div class="col-6 p-0 view-text robot"> {{rows.FirstName}}</div>
                                        </div>
                                      
                                        <div class="row mb-3">
              
                                            <div class="col-6 p-0"> <label>LastName </label>  </div>
                                            
                                            <div class="col-6 p-0 view-text"> {{rows.LastName}}</div>
                                        </div>
                                        <div class="row mb-3">
              
                                            <div class="col-6 p-0"><label> Address </label>  </div>
                                            
                                            <div class="col-6 p-0 view-text robot"> {{rows.Address}}</div>
                                        </div>
                                        <div class="row mb-3">
              
                                            <div class="col-6 p-0"> <label> City </label>  </div>
                                            
                                            <div class="col-6 p-0 view-text"> {{rows.City}}</div>
                                        </div>
                                        <div class="row mb-3">
              
                                            <div class="col-6 p-0"> <label> State</label>  </div>
                                            
                                            <div class="col-6 p-0 view-text robot">   {{rows.State }}</div>
                                        </div>
                                        <div class="row mb-3">
              
                                            <div class="col-6 p-0"> <label>ZipCode</label>  </div>
                                            
                                            <div class="col-6 p-0 view-text robot"> {{rows.ZipCode}}</div>
                                        </div>
                                        <div class="row mb-3">
              
                                          <div class="col-6 p-0"><label>  UpdatedDateTime </label>  </div>
                                          
                                          <div class="col-6 p-0 view-text"> {{rows.UpdatedDatetime  | date:'d/M/yy, h:mm a'}}</div>
                                      </div>
                                        <div class="row mb-3">
              
                                            <div class="col-6 p-0"><label> MobileNo </label>  </div>
                                            
                                            <div class="col-6 p-0 view-text robot"> {{rows.MobileNo}}</div>
                                        </div>
                                        <div class="row mb-3">
              
                                            <div class="col-6 p-0"><label>  MobileNo2</label> </div>
                                            
                                            <div class="col-6 p-0 view-text robot"> {{rows.MobileNo2}}</div>
                                        </div>
                                        <div class="row mb-3">
              
                                            <div class="col-6 p-0"><label> Email  </label> </div>
                                            
                                            <div class="col-6 p-0 view-text"> {{rows.Email}}</div>
                                        </div>
                                        <div class="row mb-3">
              
                                            <div class="col-6 p-0"><label>  Email2 </label>  </div>
                                            
                                            <div class="col-6 p-0 view-text"> {{rows.Email2}}</div>
                                        </div>
              
                                     
              
              
               
                                    </div>
                                    <div class="col-md-6">
                                        <div class="row mb-3">
              
                                            <div class="col-6 p-0"><label>  UserDefined1 </label>  </div>
                                            
                                            <div class="col-6 p-0 view-text"> {{rows.UserDefined1}}</div>
                                        </div>
                                        <div class="row mb-3">
                
                                            <div class="col-6 p-0"><label>  UserDefined2 </label>  </div>
                                            
                                            <div class="col-6 p-0 view-text"> {{rows.UserDefined2}}</div>
                                        </div>
                                        <div class="row mb-3">
                
                                            <div class="col-6 p-0"><label>  UserDefined3 </label>  </div>
                                            
                                            <div class="col-6 p-0 view-text"> {{rows.UserDefined3}}</div>
                                        </div>
                                        <div class="row mb-3">
                
                                            <div class="col-6 p-0"><label>  UserDefined4 </label>  </div>
                                            
                                            <div class="col-6 p-0 view-text"> {{rows.UserDefined4}}</div>
                                        </div>
                                        <div class="row mb-3">
                
                                            <div class="col-6 p-0"><label>  UserDefined5 </label>  </div>
                                            
                                            <div class="col-6 p-0 view-text"> {{rows.UserDefined5}}</div>
                                        </div>
                                        <div class="row mb-3">
                
                                            <div class="col-6 p-0"><label>  UserDefined6 </label>  </div>
                                            
                                            <div class="col-6 p-0 view-text"> {{rows.UserDefined6}}</div>
                                        </div>
                                        <div class="row mb-3">
                
                                            <div class="col-6 p-0"><label>  UserDefined7 </label>  </div>
                                            
                                            <div class="col-6 p-0 view-text"> {{rows.UserDefined7}}</div>
                                        </div>
                                        <div class="row mb-3">
                
                                            <div class="col-6 p-0"><label>  UserDefined8 </label>  </div>
                                            
                                            <div class="col-6 p-0 view-text"> {{rows.UserDefined8}}</div>
                                        </div>
                                        <div class="row mb-3">
                
                                            <div class="col-6 p-0"><label>  UserDefined9 </label>  </div>
                                            
                                            <div class="col-6 p-0 view-text"> {{rows.UserDefined9}}</div>
                                        </div>
                                        <div class="row mb-3">
                
                                            <div class="col-6 p-0"><label>  UserDefined10 </label>  </div>
                                            
                                            <div class="col-6 p-0 view-text"> {{rows.UserDefined10}}</div>
                                        </div>
                
                                    </div>
                                    <div class="text-center col-md-12 pt-2">
                                                       
                                        <button class="btn blue-btn" 
                                          id="Savecoupon" color="primary" 
                                          (click)="openConfirmationDialog()"
                                          >Delete </button>
                                     </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>



 
 





